import React from 'react'
import ReactModal from 'react-modal'

function ModalContainer({ children, title, isOpen = false, setIsOpen = null, runBeforeClose = null, contentStyle = {} }) {
    return (
        <ReactModal isOpen={isOpen} style={{
            overlay: {
                backgroundColor: "#0e0d0d4f",
                zIndex: 200
            },
            content: contentStyle
        }}>

            <div className='p-8'>
                <div className=' modal-control flex items-center justify-between py-2'>
                    <h1 className=' text-2xl font-bold'>{title}</h1>
                    <button onClick={() => {
                        if (runBeforeClose) runBeforeClose()
                        setIsOpen(false)
                    }} title="Close">
                        <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="currentColor" className="w-6 h-6">
                            <path strokeLinecap="round" strokeLinejoin="round" d="M6 18L18 6M6 6l12 12" />
                        </svg>

                    </button>
                </div>
                <hr className=" border mb-4" />
                <div className='modal-content overflow-auto'>
                    {children}
                </div>

            </div>
        </ReactModal>
    )
}

export default ModalContainer